/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbVisiteFormateurDto
 */
export interface FcbVisiteFormateurDto {
    /**
     * 
     * @type {number}
     * @memberof FcbVisiteFormateurDto
     */
    idvisite?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof FcbVisiteFormateurDto
     */
    idformateurs?: Array<number> | null;
}

/**
 * Check if a given object implements the FcbVisiteFormateurDto interface.
 */
export function instanceOfFcbVisiteFormateurDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbVisiteFormateurDtoFromJSON(json: any): FcbVisiteFormateurDto {
    return FcbVisiteFormateurDtoFromJSONTyped(json, false);
}

export function FcbVisiteFormateurDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbVisiteFormateurDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idvisite': !exists(json, 'idvisite') ? undefined : json['idvisite'],
        'idformateurs': !exists(json, 'idformateurs') ? undefined : json['idformateurs'],
    };
}

export function FcbVisiteFormateurDtoToJSON(value?: FcbVisiteFormateurDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idvisite': value.idvisite,
        'idformateurs': value.idformateurs,
    };
}

